import {
  Card,
  Typography,
  CardContent,
  CardActionArea,
  Grid,
} from "@mui/material";

import { Client } from "../../../models/client/client.model";
import Colors from "../../../constants/Colors";

interface Props {
  client: Client;
  closeModal: () => void;
  onSelectClient: (client: Client) => void;
}

const VisitClientCard = ({
  client,
  closeModal,
  onSelectClient,
}: Props): JSX.Element => {
  const {
    apelido,
    categoria,
    nome,
    tipoPessoaId: pessoa,
    cnpjCpf,
    rg,
  } = client;

  const handleSelectClient = () => {
    onSelectClient(client);
    closeModal();
  };

  return (
    <Card
      sx={{
        height: "100%",
        marginTop: "2%",
        marginBottom: "2%",
        boxShadow: 3,
      }}
    >
      <CardActionArea onClick={handleSelectClient} sx={{ height: "100%" }}>
        <CardContent>
          <Typography
            variant="body2"
            fontWeight={"bold"}
            color={Colors.primary}
            fontSize={16}
          >
            {apelido}
          </Typography>
          <Typography variant="body2">{nome}</Typography>
          <Typography variant="body2">{categoria}</Typography>
          {pessoa === "J" ? (
            <Typography variant="body2" color={"gray"}>
              {cnpjCpf}
            </Typography>
          ) : (
            <Grid container>
              <Grid item xs={6} md={6}>
                <Typography variant="body2" color={"gray"}>
                  {cnpjCpf}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6} textAlign={"right"}>
                <Typography variant="body2" color={"gray"}>
                  {rg ? rg : ""}
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default VisitClientCard;
